<template>
  <p>
    If you're a new freegler then welcome! You'll get emails. Name, approx.
    location, and profile picture are public - you can hide your real name and
    picture from Settings. This adds cookies and local storage. Read
    <nuxt-link no-prefetch target="_blank" to="/terms">Terms of Use</nuxt-link>
    and
    <nuxt-link no-prefetch target="_blank" to="/privacy">Privacy</nuxt-link> for
    details.
  </p>
</template>
<script>
export default {}
</script>
